import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FiltreService } from 'src/app/shared/filtre.service';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-premiers-contacts',
  templateUrl: './premiers-contacts.component.html',
  styleUrls: ['./premiers-contacts.component.css']
})
export class PremiersContactsComponent implements OnInit, OnDestroy {
  @Input()
  erreursMap: Map<string, string>;
  private subTab: Subscription[] = [];
  private subFormulaire: Subscription;

  public infobulleTotaux: string = 'Le bouton "Calcul Totaux" constitue un outil d\'aide à la saisie. \
    Attention à ne pas l\'utiliser si vous saisissez directement un total sans saisir toutes les valeurs détails,\
    sinon le total que vous avez saisi sera écrasé par le recalcul déclenché par le clic sur le bouton de calcul...';

  constructor(
    private formulaireService: FormulaireService,
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService,
    public saisieService: SaisieService,
    public filtreService: FiltreService
  ) { }

  ngOnInit(): void {
    // Pour rafraichir les variables possedant des controles croisés inter onglets !!
    //CtrlB4
    this.filtreService.refreshErreur(this.subTab, 'dg', 'xxPremContactTot', 'premiersContacts', 'bbPremContactOrigTot');
    //CtrlB5
    this.filtreService.refreshErreur(this.subTab, 'dg', 'xxPremContactTot', 'premiersContacts', 'bbPremContactModeTot');
    //CtrlB6
    this.filtreService.refreshErreur(this.subTab, 'dg', 'xxPremContactVictTot', 'premiersContacts', 'bbPremContactOrientTot');

    // Mises à jours de la synthèse si une zone bouge sur l'onglet
    this.subFormulaire = this.formulaire.valueChanges.pipe(distinctUntilChanged(), debounceTime(100)).subscribe(valeur => {
      this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.formulaireService.getRootForm().get('bav').get('detailBavs'));
    });
    this.formulaire.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    if (this.subFormulaire) {
      this.subFormulaire.unsubscribe();
    }
    if (this.subTab.length !== 0) {
      this.subTab.forEach(element => element.unsubscribe());
    }
  }

  public get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm().get('premiersContacts') as UntypedFormGroup;
  }

  public calculTotalTableauB1(): void {
    //Calcul Total bbPremContactOrigTot 
    this.saisieService.calculTotal2(this.formulaire, 'bbPremContactOrigTot', 'bbPremContactOrigAsso', 'bbPremContactOrigPerso');
  }

  public calculTotalTableauB2(): void {
    //Calcul Total bbPremContactModeTot 
    this.saisieService.calculTotal3(this.formulaire, 'bbPremContactModeTot', 'bbPremContactModeEcrit', 'bbPremContactModeTel', 'bbPremContactModePres');
  }

  public calculTotalTableauB3(): void {
    //Calcul Total bbPremContactOrientTot 
    this.saisieService.calculTotal15(this.formulaire, 'bbPremContactOrientTot', 'bbPremContactOrientProc', 'bbPremContactOrientAutjud', 'bbPremContactOrientPenit', 'bbPremContactOrientPolgend', 'bbPremContactOrientUmj', 'bbPremContactOrientHosto', 'bbPremContactOrientColter', 'bbPremContactOrientAsso', 'bbPremContactOrientSad', 'bbPremContactOrientPftel', 'bbPremContactOrientFrvict', 'bbPremContactOrientPart', 'bbPremContactOrientPub', 'bbPremContactOrientRela', 'bbPremContactOrientAutr');
  }

}
